module.exports = __webpack_public_path__ + "img/cp.5498420c.jpg";